import { Component, OnInit } from '@angular/core';
import { SubSink } from 'subsink';
import { Pagination } from 'src/app/shared/models/pagination.model';
import { TransferMode, WithdrawRialStatus } from 'src/app/shared/models/withdraw.model';
import { User } from 'src/app/shared/models/user.model';
import { Currency } from 'src/app/shared/models/currency.model';
import Swal from 'sweetalert2';
import { ReportService } from 'src/app/shared/service/report.service';
import { LazyLoadEvent } from 'primeng/api';
import { Provider, WithdrawRial } from 'src/app/shared/models/withdraw-rial.model';
import { HttpError } from '../../../../../shared/models/http-error.model';
import { UserService } from '../../../../../shared/service/user.service';
import { NoteComponent } from '../../../../../shared/components/note/note.component';
import { NbDialogService } from '@nebular/theme';
import { from, of } from 'rxjs';
import { catchError, concatMap, delay } from 'rxjs/operators';

@Component({
  selector: 'app-edit-pools-details',
  templateUrl: './withdraw-rial.component.html',
  styleUrls: ['./withdraw-rial.component.scss']
})
export class WithdrawRialComponent implements OnInit {
  sub = new SubSink();
  tableLoading = true;
  error: any = {};
  pagination: Pagination<WithdrawRial> = new Pagination<WithdrawRial>();
  loading = true;
  page = 1;
  limit = 50;
  includedUsers: User[] = [];
  selectedCurrency: Currency[] = [];
  Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });
  saveLoading = false;
  errors: any = {};
  selectedWithdraw!: WithdrawRial;
  withdrawStatus!: WithdrawRialStatus;
  Provider = Provider;

  transferStatus!: TransferMode;
  transferMode = TransferMode;
  protected readonly WithdrawRialStatus = WithdrawRialStatus;
  protected readonly TransferMode = TransferMode;
  batchProvider: Provider = 'JIBIT' as Provider;
  batchTransferMode = 'NORMAL' as TransferMode;
  batchStatus = 'SUCCESSFUL';
  saveBatchLoading = false;

  constructor(
    private reportService: ReportService,
    private userService: UserService,
    private dialogService: NbDialogService
  ) {
  }

  openNote(userId: number): void {
    this.dialogService.open(NoteComponent, {
      hasBackdrop: true,
      dialogClass: 'note-modal-container',
      context: {
        userId
      }
    });
  }


  changeBatchStatus() {
    this.saveBatchLoading = true;
    const withdraws = this.pagination.data;
    const requests = [];
    for (const withdraw of withdraws) {
      if (withdraw.selectedWithdraw) {
        requests.push(this.userService.updateWithdrawRial(this.batchStatus, withdraw.id, this.batchProvider, this.batchTransferMode));
      }
    }
    let completedItems = 0;
    from(requests).pipe(
      concatMap(request =>
        request.pipe(
          catchError(response => {
            if (response.status !== 422) {
              this.Toast.fire({ icon: 'error', text: response.error });
            }
            if (response.status === 422) {
              this.errors = response.validationError;
              if (this.errors?.status !== undefined) {
                this.Toast.fire({ icon: 'error', text: this.errors.status[0] });
              }
              if (this.errors?.message !== undefined) {
                this.Toast.fire({ icon: 'error', text: this.errors.message[0] });
              }
            }
            return of(null);
          }),
          delay(1100)
        )
      )
    ).subscribe(
      response => {
        if (response) {
          this.Toast.fire({ icon: 'success', text: response.message });
        }
      },
      () => {
      },
      () => {
        this.saveBatchLoading = false;
        this.getDepositList();
      }
    );

  }

  changeRecordPerPageLimit(limit: number): void {
    this.limit = limit;
    this.getDepositList({
      first: 0,
      rows: limit
    });
  }

  withdrawTypeChanged(tabData: any): void {
    this.loading = true;
    this.withdrawStatus = tabData.tabId;
  }

  changeStatus(withdraw: WithdrawRial): void {
    this.saveLoading = true;
    this.errors = {};
    this.selectedWithdraw = withdraw;
    this.sub.sink = this.userService
      .updateWithdrawRial(withdraw.status, withdraw.id, withdraw.provider, withdraw.transferMode)
      .subscribe(
        (response: any) => {
          this.Toast.fire({ icon: 'success', text: response.message });
          this.pagination.data.splice(this.pagination.data.indexOf(withdraw), 1);
          this.saveLoading = false;
        },
        (response: HttpError) => {
          if (response.status !== 422) {
            this.Toast.fire({ icon: 'error', text: response.error });
          }
          if (response.status === 422) {
            this.errors = response.validationError;
            if (this.errors?.status !== undefined) {
              this.Toast.fire({ icon: 'error', text: this.errors.status[0] });
            }
            if (this.errors?.message !== undefined) {
              this.Toast.fire({ icon: 'error', text: this.errors.message[0] });
            }
          }
          this.saveLoading = false;
        }
      );
  }

  copy(text: string, alert: string): void {
    navigator.clipboard.writeText(text);
    this.Toast.fire({ icon: 'success', text: alert });
  }

  getDepositList(event: LazyLoadEvent = {}): void {
    this.loading = true;
    if (event.first !== undefined && event.rows !== undefined) {
      this.page = event?.first / this.limit + 1;
    }
    const userIds = this.includedUsers.map((user) => user.id);
    this.reportService
      .getRialWithdrawList(userIds, this.page, event.rows, this.withdrawStatus)
      .subscribe((pagination) => {
        this.pagination = pagination;
        for (const withdraw of this.pagination.data) {
          if (!withdraw.provider) {
            withdraw.provider = Provider.jibit;
          }
        }
        this.loading = false;
      });
  }

  selectAll() {
    const withdraws = this.pagination.data;
    for (const withdraw of withdraws) {
      withdraw.selectedWithdraw = true;
    }
  }
  deSelectAll() {
    const withdraws = this.pagination.data;
    for (const withdraw of withdraws) {
      withdraw.selectedWithdraw = false;
    }
  }

  ngOnInit(): void {
  }


}
